<template>
    <b-badge v-if="statusInfo" :variant="statusInfo.variant">
        {{ statusInfo.text }}
    </b-badge>
    <span v-else>-</span>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    components: {
        BBadge
    },
    props: {
        row: Object, 
        field: [Number, String]
    },
    data() {
        return {
            statusMap: {
                0: { text: 'Ödeme Bekleniyor', variant: 'light-warning' },
                1: { text: 'Diğer Ödemeler Bekleniyor', variant: 'light-info' },
                2: { text: 'Ödendi', variant: 'light-success' },
                3: { text: 'Pasif', variant: 'light-secondary' },
                4: { text: 'Onay Sürecinde', variant: 'light-info' }
            }
        }
    },
    computed: {
        statusInfo() {
            return this.field != null ? this.statusMap[this.field] : null
        }
    }
}
</script>